import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { DockItemFacade } from '../../../dock/item/dock-item.facade';
import { CompartmentItemFacade } from '../../../compartment/item/compartment-item.facade';
import { ClosedPeriodItemState, ClosedPeriodItemStateModel } from './closed-period-item.state';
import { ClosedPeriodModel } from '../models';
import {
  ClosedPeriodItemInitialState,
  ClosedPeriodItemCreate,
  ClosedPeriodItemDelete,
  ClosedPeriodItemLoad,
  ClosedPeriodItemUpdate,
} from './closed-period-item.actions';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class ClosedPeriodItemFacade implements LoadDataFacade, SetInitialStateFacade {
  closedPeriod$: Observable<ClosedPeriodItemStateModel> = this.store.select(ClosedPeriodItemState.getState);
  loaded$: Observable<boolean> = this.store.select(ClosedPeriodItemState.getLoaded);

  private relationIds$: Observable<[number, number]> = combineLatest([
    this.compartmentItemFacade.compartmentId$,
    this.dockItemFacade.dockId$,
  ]).pipe(take(1));

  constructor(
    private store: Store,
    private compartmentItemFacade: CompartmentItemFacade,
    private dockItemFacade: DockItemFacade,
  ) {}

  loadAll(closedPeriodId: number): void {
    this.relationIds$.subscribe(([compartmentId, dockId]: [number, number]) => {
      this.store.dispatch(
        new ClosedPeriodItemLoad({
          closedPeriodId,
          compartmentId,
          dockId,
        }),
      );
    });
  }

  createPeriod(data: ClosedPeriodModel, dialog: MatDialogRef<unknown>): void {
    this.relationIds$.subscribe(([compartmentId, dockId]: [number, number]) => {
      this.store.dispatch(
        new ClosedPeriodItemCreate({
          data,
          dialog,
          compartmentId,
          dockId,
        }),
      );
    });
  }

  updatePeriod(data: ClosedPeriodModel, dialog: MatDialogRef<unknown>): void {
    this.relationIds$.subscribe(([compartmentId, dockId]: [number, number]) => {
      this.store.dispatch(
        new ClosedPeriodItemUpdate({
          data,
          dialog,
          compartmentId,
          dockId,
        }),
      );
    });
  }

  deletePeriod(closedPeriodId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.relationIds$.subscribe(([compartmentId, dockId]: [number, number]) => {
      this.store.dispatch(
        new ClosedPeriodItemDelete({
          closedPeriodId,
          dialog,
          compartmentId,
          dockId,
        }),
      );
    });
  }

  setInitialState(): void {
    this.store.dispatch(new ClosedPeriodItemInitialState());
  }
}
